
export const RULE_TAB_LEVEL = "level";
export const RULE_TAB_GL = "gl";

export const RULE_TABS = [
  {
    label: "Allocation Rules by Level",
    value: RULE_TAB_LEVEL,
  },
  {
    label: "Allocation Rules by GL",
    value: RULE_TAB_GL,
  },
];

export const ruleRows = [
  {
    key: "EQUAL_DISTRIBUTION",
    label: "Equal Allocation",
    statusLabel: "Weights not configured"
  },
  {
    key: "FIXED_WEIGHTS",
    label: "Fixed Weights",
    statusLabel: "Weights not configured"
  },
  {
    key: "WEIGHING_FACTORS",
    label: "Weighted Factor",
    statusLabel: "Metric table not configured"
  },
  {
    key: "SQUARE_FOOTAGE",
    label: "Square Footage",
    statusLabel: "Metric table not configured"
  },
];

export const RULE_ID = "distributionRuleId";